<div class="d-flex flex-column w-100 h-100">
  <div style="margin-top: 40px">
    <app-header class="h-10"></app-header>
  </div>
  <div class="h-80 d-flex justify-content-center align-items-center">
    <nz-spin [nzSpinning]="loading">
      <div>
        <nz-result
          *ngIf="code === 'Accept'"
          nzStatus="success"
          nzTitle="{{ 'accept-meeting' | translate }}"
        >
        </nz-result>
      </div>
      <div>
        <nz-result
          *ngIf="code === 'Reject'"
          nzStatus="error"
          nzTitle="{{ 'reject-meeting' | translate }}"
        ></nz-result>
      </div>
      <div>
        <nz-result
          *ngIf="code === 'Error'"
          nzStatus="error"
          [nzTitle]="errorMsg"
        ></nz-result>
      </div>

      <!-- <div class="date-wrapper" *ngIf="code==='Reject'">
        <div *ngIf="!successFlag">
          <label>{{'suggested-date'|translate}}</label>
          <div><nz-date-picker class="w-100"  [(ngModel)]="suggestedDate" [nzDisabledDate]="disabledDate" [nzShowTime]="true"></nz-date-picker></div>
          <p class="invalid-feedback mt-2" *ngIf="!suggestedDate&&submitted()">{{'shared.thisFieldIsRequired'|translate}}</p>
        </div>
        <button class="mt-3" nz-button nzType="primary" *ngIf="!successFlag" (click)="performAction()">{{'shared.send'|translate}}</button>

        <div *ngIf="successFlag">
          <p style="text-align: center;margin-bottom: 5px"><span  nz-icon [nzType]="'check-circle'" style="font-size: 40px" [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"></span></p>
          <p >{{message|translate}}</p>
        </div>


      </div> -->
    </nz-spin>
  </div>
  <div class="h-10">
    <app-footer></app-footer>
  </div>
</div>
